/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { NodeCompat } from '../../../compat/NodeCompat';
import { IServerParent } from '../../../core/models/common/IServerParent';
import { Server } from '../../../core/models/common/Server';
import { OasOperation } from '../../models/OasOperation';
import { OasParameter } from '../../models/OasParameter';
import { OasPathItem } from '../../models/OasPathItem';

/**
 * Constructor.
 * @param {string} path
 * @class
 * @extends OasPathItem
 * @author eric.wittmann@gmail.com
 */
export class Oas30PathItem extends OasPathItem implements IServerParent {
    public summary : string;

    public description : string;

    public trace : Oas30Operation;

    public servers : Array<Server>;

    public constructor(path : string) {
        super(path);
        if(this.summary===undefined) this.summary = null;
        if(this.description===undefined) this.description = null;
        if(this.trace===undefined) this.trace = null;
        if(this.servers===undefined) this.servers = null;
    }

    /**
     * @see io.apicurio.datamodels.openapi.models.OasPathItem#createOperation(java.lang.String)
     * @param {string} method
     * @return {OasOperation}
     */
    public createOperation(method : string) : OasOperation {
        let rval : OasOperation = new Oas30Operation(method);
        rval._ownerDocument = this.ownerDocument();
        rval._parent = this;
        return rval;
    }

    /**
     * @see io.apicurio.datamodels.openapi.models.OasPathItem#createParameter()
     * @return {OasParameter}
     */
    public createParameter() : OasParameter {
        let rval : OasParameter = new Oas30Parameter();
        rval._ownerDocument = this.ownerDocument();
        rval._parent = this;
        return rval;
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.IServerParent#createServer()
     * @return {Server}
     */
    public createServer() : Server {
        let rval : Oas30Server = new Oas30Server();
        rval._ownerDocument = this.ownerDocument();
        rval._parent = this;
        return rval;
    }

    public addServer$io_apicurio_datamodels_openapi_v3_models_Oas30Server(server : Oas30Server) {
        if(this.servers == null) {
            this.servers = <any>([]);
        }
        /* add */(this.servers.push(server)>0);
    }

    /**
     * Adds a server.
     * @param {Oas30Server} server
     */
    public addServer(server? : any) : any {
        if(((server != null && server instanceof <any>Oas30Server) || server === null)) {
            return <any>this.addServer$io_apicurio_datamodels_openapi_v3_models_Oas30Server(server);
        } else if(((server != null && server instanceof <any>Server) || server === null)) {
            return <any>this.addServer$io_apicurio_datamodels_core_models_common_Server(server);
        } else throw new Error('invalid overload');
    }

    /**
     * Gets the servers.
     * @return {Server[]}
     */
    public getServers() : Array<Server> {
        return this.servers;
    }

    /**
     * @see io.apicurio.datamodels.openapi.models.OasPathItem#setOperation(io.apicurio.datamodels.openapi.models.OasOperation)
     * @param {OasOperation} operation
     */
    public setOperation(operation : OasOperation) {
        if(NodeCompat.equals("trace", operation.getMethod())) {
            this.trace = <Oas30Operation>operation;
        } else {
            super.setOperation(operation);
        }
    }

    public addServer$io_apicurio_datamodels_core_models_common_Server(server : Server) {
        if(this.servers == null) {
            this.servers = <any>([]);
        }
        /* add */(this.servers.push(<Oas30Server>server)>0);
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.IServerParent#getServer(java.lang.String)
     * @param {string} url
     * @return {Server}
     */
    public getServer(url : string) : Server {
        if(this.servers != null) {
            for(let index165=0; index165 < this.servers.length; index165++) {
                let server = this.servers[index165];
                {
                    if(NodeCompat.equals(server.url, url)) {
                        return server;
                    }
                }
            }
        }
        return null;
    }
}
Oas30PathItem["__class"] = "io.apicurio.datamodels.openapi.v3.models.Oas30PathItem";
Oas30PathItem["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IReferenceNode","io.apicurio.datamodels.openapi.models.IOasParameterParent","io.apicurio.datamodels.core.models.common.IServerParent"];





import { Oas30Server } from './Oas30Server';


import { Oas30Parameter } from './Oas30Parameter';


import { Oas30Operation } from './Oas30Operation';

